import Step from './Step'
import Stepper from './Stepper'

Stepper.Step = Step

export default Stepper
